// 0-待支付 1-成功 2-失败 3-关闭 4-退款中 5-退款成功 6-退款失败 7-部分退款 101消费 102撤销 103退货 104-预授权 105-预授权撤销 106-预授权完成 107-预授权完成撤销 108-现金支付
const PAY_STATUS = {
  awitPay: '0',
  success: '1',
  fail: '2',
  close: '3',
  refunding: '4',
  refundSuccess: '5',
  refundFail: '6',
  rebates: '7',
  consumption: '101',
  revocation: '102',
  returns: '103',
  preAuthorization: '104',
  preauthorizationRevocation: '105',
  preAuthorizationCompletion: '106',
  preAuthorizationCompletionRevocation: '107',
  cashPay: '108',
  cashPayRefund: '109',
};
const PAY_SUCCESS = [
  PAY_STATUS.success,
  PAY_STATUS.refundSuccess,
  PAY_STATUS.consumption,
  PAY_STATUS.revocation,
  PAY_STATUS.returns,
  PAY_STATUS.preAuthorization,
  PAY_STATUS.preauthorizationRevocation,
  PAY_STATUS.preAuthorizationCompletion,
  PAY_STATUS.preAuthorizationCompletionRevocation,
];
const PAY_REFUND = [
  PAY_STATUS.refunding,
  PAY_STATUS.refundSuccess,
  PAY_STATUS.refundFail,
  PAY_STATUS.rebates,
  PAY_STATUS.preAuthorizationCompletionRevocation,
];
const PAY_STATUS_LIST = [
  { value: PAY_STATUS.awitPay, label: '待支付' },
  { value: PAY_STATUS.success, label: '成功' },
  { value: PAY_STATUS.fail, label: '失败' },
  { value: PAY_STATUS.close, label: '关闭' },
  { value: PAY_STATUS.refunding, label: '退款中' },
  { value: PAY_STATUS.refundSuccess, label: '退款成功' },
  { value: PAY_STATUS.refundFail, label: '退款失败' },
  // { value: PAY_STATUS.rebates, label: "部分退款" },
  { value: PAY_STATUS.preAuthorization, label: '预授权' },
  { value: PAY_STATUS.preauthorizationRevocation, label: '预授权撤销' },
  { value: PAY_STATUS.preAuthorizationCompletion, label: '预授权完成' },
  {
    value: PAY_STATUS.preAuthorizationCompletionRevocation,
    label: '预授权完成撤销',
  },
  { value: PAY_STATUS.cashPay, label: '现金支付' },
  { value: PAY_STATUS.cashPayRefund, label: '现金支付退款' },
];
const PAY_TYPE_LIST = [
  {
    value: 'ALIPAY',
    label: '支付宝',
  },
  {
    value: 'WECHAT',
    label: '微信',
  },
  {
    value: 'CARD',
    label: '刷卡消费',
  },
  {
    value: 'PRE_AUTH',
    label: '预授权',
  },
  {
    value: 'UNIONPAY',
    label: '银联',
  },
  {
    value: 'PC_PAY',
    label: '网银',
  },
  {
    value: 'CASH',
    label: '现金支付',
  },
];
const GATHERING_TYPE_LIST = [
  {
    value: '1',
    label: '极速开票码收款',
  },
  {
    value: '12',
    label: '极速开票码（小程序）收款',
  },
  {
    value: '2',
    label: '动态码收款',
  },
  {
    value: '3',
    label: '微信APP收款',
  },
  {
    value: '4',
    label: '商户主扫收款',
  },
  {
    value: '5',
    label: '商户主扫API收款',
  },
  {
    value: '6',
    label: 'JSAPI收款',
  },
  {
    value: '7',
    label: '外部同步订单',
  },
  {
    value: '8',
    label: '网银收款',
  },
  {
    value: '9',
    label: '小程序支付',
  },
  {
    value: '11',
    label: '商户主扫预授权收款',
  },
];
const MAKE_INVOICE_LIST = [
  {
    name: '开票中',
    val: 3,
  },
  {
    name: '开票失败',
    val: 2,
  },
  {
    name: '已开票',
    val: 1,
  },
  {
    name: '未开票',
    val: 0,
  },
  {
    name: '自动提交',
    val: 4,
  },
  {
    name: '已线下开票',
    val: 5,
  },
  {
    name: '禁止开票（线下退款）',
    val: 6,
  },
];
// 支付通道
/**
 * WECHAT("微信直连", 0),
    ZHONGFU("中付", 1),
    WANGSHANG("网商", 2),
    WSBLUE("网商蓝海行动", 3),
    AISINO("航信", 4),
    SPDB("浦发", 5),
    SUIXINGFU("随行付", 6),
    ZHONGFUPOS("中付pos", 7),
    BAOFU("宝付", 8),
    XUNXIN("迅信", 9),
    YUNSHANFU("云闪付", 10),
    CEB("光大", 11),
    JLPAY("嘉联", 12);
 */
const PAY_CHANNEL = [
  // {
  //   value: "0",
  //   label: "微信直连"
  // },
  {
    value: '1',
    label: '中付',
  },
  {
    value: '2',
    label: '网商',
  },
  // {
  //   value: "3",
  //   label: "网商(蓝海行动)"
  // },
  // {
  //   value: "4",
  //   label: "航信"
  // },
  {
    value: '5',
    label: '浦发',
  },
  {
    value: '6',
    label: '随行付',
  },
  {
    value: '7',
    label: '中付pos',
  },
  {
    value: '8',
    label: '宝付',
  },
  // {
  //   value: "9",
  //   label: "迅信"
  // },
  // {
  //   value: "10",
  //   label: "云闪付"
  // },
  // {
  //   value: "11",
  //   label: "光大"
  // },
  {
    value: '12',
    label: '嘉联',
  },
  {
    value: '14',
    label: '联动',
  },
  {
    value: '16',
    label: '微信支付',
  },
];
export {
  PAY_STATUS,
  PAY_SUCCESS,
  PAY_REFUND,
  PAY_STATUS_LIST,
  PAY_TYPE_LIST,
  GATHERING_TYPE_LIST,
  MAKE_INVOICE_LIST,
  PAY_CHANNEL,
};
